import styles from './Avatar.module.css'
import type { UserStatus } from '../../api/types'

const STATUS_COLORS: Record<UserStatus, string> = {
  ACTIVE: 'var(--success)',
  AWAY: 'var(--warning)',
  DO_NOT_DISTURB: 'var(--danger)',
  OFFLINE: 'var(--text-muted)',
}

interface AvatarProps {
  name: string
  imageUrl?: string | null
  size?: 'md' | 'lg'
  status?: UserStatus
}

export function Avatar({ name, imageUrl, size = 'md', status }: AvatarProps) {
  const initials = name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')

  return (
    <span style={{ display: 'inline-block', position: 'relative' }}>
      <span className={[styles.avatar, size === 'lg' ? styles.lg : ''].join(' ')}>
        {imageUrl ? <img src={imageUrl} alt="" /> : initials}
      </span>
      {status ? (
        <span
          className={styles.statusDot}
          style={{ position: 'absolute', bottom: 0, right: 0, background: STATUS_COLORS[status] }}
          aria-label={status}
        />
      ) : null}
    </span>
  )
}
